import React from 'react'
import '../../styles/Payment/PaymentError.css'
import { Fade } from 'react-awesome-reveal'
import { Col, Row } from 'react-bootstrap'
import logo from '../../assets/logo.jpg'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function PaymentError() {

    return (

        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <meta name="title" content="Paiement refusé - E5M Diagnostics" />
                <meta name="description" content="Paiement refusé de E5M Diagnostics." />
            </Helmet>

            <BrowserView>
                <div id='paymentError'>
                    <Row>
                        <Col sm={8}>
                            <Fade direction={'down'}>
                                <div id='paymentErrorLeft'>
                                    <h1 id='paymentErrorLeftTitle'>
                                        <FontAwesomeIcon icon={faXmark} className='paymentErrorLeftIcon' />
                                        Paiement refusé
                                        <FontAwesomeIcon icon={faXmark} className='paymentErrorLeftIcon' />
                                    </h1>
                                    <img src={logo} id='paymentErrorLeftLogo' alt='logo' />
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={4}>
                            <Fade direction={'up'}>
                                <div id='paymentErrorRight'>
                                    <div id='paymentErrorRightTitle'>
                                        Quelque chose c'est mal passé durant le traitement de votre paiement
                                        <br />
                                        Il n'a pas été pris en compte
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='paymentError'>
                    <Row>
                        <Col sm={8}>
                            <Fade direction={'down'}>
                                <div id='paymentErrorLeftMobile'>
                                    <h1 id='paymentErrorLeftTitleMobile'>
                                        <FontAwesomeIcon icon={faXmark} className='paymentErrorLeftIconMobile' />
                                        Paiement refusé
                                        <FontAwesomeIcon icon={faXmark} className='paymentErrorLeftIconMobile' />
                                    </h1>
                                    <img src={logo} id='paymentErrorLeftLogoMobile' alt='logo' />
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={4}>
                            <Fade direction={'up'}>
                                <div id='paymentErrorRightMobile'>
                                    <div id='paymentErrorRightTitleMobile'>Quelque chose c'est mal passé durant le traitement de votre paiement</div>
                                    <div id='paymentErrorRightTitleMobile'>Il n'a pas été pris en compte</div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </MobileView>
        </>

    )

}

export default PaymentError